var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 48,
    viewBox: "0 0 68 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_31050)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18_31050)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_18_31050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 0.5H3C1.61929 0.5 0.5 1.61929 0.5 3V37C0.5 38.3807 1.61929 39.5 3 39.5H57C58.3807 39.5 59.5 38.3807 59.5 37V3C59.5 1.61929 58.3807 0.5 57 0.5Z",
    fill: "#1F72CD",
    stroke: "#D5DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6137 14L5 26.423H11.7204L12.5536 24.4422H14.4579L15.2911 26.423H22.6883V24.9112L23.3475 26.423H27.1739L27.8331 24.8793V26.423H43.2174L45.0881 24.4937L46.8397 26.423L54.7414 26.439L49.11 20.2462L54.7414 14H46.9623L45.1413 15.8936L43.4448 14H26.7087L25.2715 17.2065L23.8007 14H17.0943V15.4603L16.3483 14H10.6137ZM33.5871 15.7641H42.4215L45.1236 18.6828L47.9127 15.7641H50.6147L46.5093 20.2444L50.6147 24.6731H47.7901L45.0881 21.7205L42.2847 24.6731H33.5871V15.7641ZM35.7687 19.2371V17.6098V17.6082H41.2811L43.6864 20.2107L41.1746 22.8274H35.7687V21.0509H40.5883V19.2371H35.7687ZM11.9141 15.7641H15.1899L18.9135 24.1882V15.7641H22.5021L25.3781 21.8041L28.0287 15.7641H31.5993V24.6784H29.4267L29.409 17.6932L26.2414 24.6784H24.2979L21.1127 17.6932V24.6784H16.643L15.7957 22.6799H11.2177L10.3721 24.6766H7.97735L11.9141 15.7641ZM11.9994 20.8325L13.5077 17.2723L15.0142 20.8325H11.9994Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_31050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_31050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_18_31050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterImg4);
export default __webpack_public_path__ + "static/media/FooterImg4.5e801c94957320340fac8a28321ce216.svg";
export { ForwardRef as ReactComponent };